import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';

import useCraRdv from '../../hooks/useCraRdv';
import useRole from '../../hooks/useRole';

export default function CalendarHeader() {
    const { monthCalendarIndex, setMonthCalendarIndex } = useCraRdv();
    const { i18n } = useTranslation();
    const role = useRole();
    function handlePrevMonth() {
        setMonthCalendarIndex(monthCalendarIndex - 1);
        console.log('handlePrevMonth');
    }
    function handleNextMonth() {
        setMonthCalendarIndex(monthCalendarIndex + 1);
        console.log('handleNextMonth');
    }
    console.log(monthCalendarIndex);

    return (
        <div className='frame000ParaCompte'>
            {role == 'admin' &&
                <div className='frame5Profile'>{i18n.t('Gestion des candidatures')} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}> {i18n.t('Gestion des RDV')}</span> </div>
            }
            {role == 'client' &&
                <div className='frame5Profile'>{i18n.t('Appels d\'offres')} &gt; <span style={{ color: 'rgba(39, 45, 60, 1)' }}> {i18n.t('Mes RDV')}</span> </div>
            }
            <h4 className='titlesociete'>
                {i18n.t('Gestion des RDV')}
            </h4>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '8px', alignSelf: 'stretch', justifyContent: 'flex-end' }}>
                <h2
                    // className="ml-4 text-xl text-gray-500 font-bold"
                    style={{
                        //marginLeft: '1rem',
                        color: '#6B7280',
                        fontSize: '1.25rem',
                        lineHeight: '1.75rem',
                        fontWeight: '700',
                    }}
                >
                    {dayjs(new Date(dayjs().year(), monthCalendarIndex)).format(
                        'MMMM YYYY'
                    )}
                </h2>
                <IconButton
                    //  contained
                    sx={{ color: '#272D3C', padding: '0px' }}
                    onClick={handlePrevMonth}
                >
                    <ChevronLeft />
                </IconButton>
                <IconButton
                    sx={{ color: '#272D3C', padding: '0px' }}
                    onClick={handleNextMonth}
                >
                    <ChevronRight />
                </IconButton>
            </div>
            {/*<header
            // className="px-4 py-2 flex items-center"
                style={{display: 'flex',
                    //paddingTop: '0.5rem',
                    //paddingBottom: '0.5rem',
                    //paddingLeft: '1rem',
                    //paddingRight: '1rem',
                    alignItems: 'center',}}
            >
                <h2
                // className="ml-4 text-xl text-gray-500 font-bold"
                    style={{
                        //marginLeft: '1rem',
                        color: '#6B7280',
                        fontSize: '1.25rem',
                        lineHeight: '1.75rem',
                        fontWeight: '700',}}
                >
                    {dayjs(new Date(dayjs().year(), monthCalendarIndex)).format(
                        'MMMM YYYY'
                    )}
                </h2>
            </header>*/}
        </div>
    );
}
